import React, { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { motion, AnimatePresence } from 'framer-motion';
import { updateDetailPage } from '../store/globalReducer';

import PageNotFound from '../components/PageNotFound';

import iconBack from '../assets/img/common/icon_back.svg';
import iconPin from '../assets/img/common/icon_pin.svg';
import iconAddress from '../assets/img/common/icon_address.svg';
import iconPlant from '../assets/img/common/icon_plant.svg';
import iconCaret from '../assets/img/common/icon_caret.svg';

import logoImg from '../assets/img/common/logo_beige.svg';

import '../assets/scss/pages/detail.scss';

export default function DetailPage() {
  const location = useLocation();
  const dispatch = useDispatch();

  const templeList = useSelector(state => state.temples.templeData);
  const [templeData, setTempleData] = useState({});
  const [seeMore, setSeeMore] = useState(false);

  useEffect(() => {
    dispatch(updateDetailPage(true));
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const currentTempleName = location.pathname.replace('/', '');
    const currentTemple = templeList.find(el => el.name_en === currentTempleName);
    setTempleData(currentTemple);
  }, [location, templeData, templeList]);

  const handleMoreClick = e => {
    e.preventDefault();
    setSeeMore(!seeMore);
  }

  const parseTitleLines = titleStr => {
    if (!titleStr) return;
    const parsedLines = titleStr.split(/\n/);
    return parsedLines;
  }

  if (!templeData) {
    return <PageNotFound />
  }

  return (
    <div className="page-detail">
      <div className="detail">
        <div className="detail__inner">
          <div className="detail__back detail__back--top">
            <Link to={`/${templeData.show_on_map === 'index' ? '' : templeData.show_on_map}`}>
              <i><img src={iconBack} alt="" /></i>
              <span>Back</span>
            </Link>
          </div>
          <div className="detail__head">
            {templeData.detail_title && (
              <h1 className="detail__heading">
                {parseTitleLines(templeData.detail_title).map((line, id) => (
                  <React.Fragment key={id}>
                    <span>{line}</span>
                    <br />
                  </ React.Fragment>
                ))}
              </h1>
            )}
            {templeData.detail_icon_url && (
              <div className="detail__head-image">
                <img src={`${process.env.PUBLIC_URL}/detail_images/icons/${templeData.detail_icon_url}`} alt="" />
              </div>
            )}
          </div>
          <div className="detail__body">
            <div className="detail__block">
              {templeData.detail_image_url_1 && (
                <figure className="detail__image">
                  <img src={`${process.env.PUBLIC_URL}/detail_images/images/${templeData.detail_image_url_1}`} alt={templeData.name_jp} />
                </figure>
              )}

              <div className="detail__meta">
                <div className="detail__meta-item detail__location">
                  {templeData.name_jp && (
                    <div className="detail__name">
                      <i><img src={iconPin} alt="" /></i>
                      <p>{templeData.name_jp}</p>
                    </div>
                  )}
                  {templeData.google_map_url && (
                    <div className="detail__map"><a href={`${templeData.google_map_url}`} target="_blank" rel="noreferrer">Google Map</a></div>
                  )}
                </div>
                {templeData.address && (
                  <div className="detail__meta-item detail__address">
                    <i><img src={iconAddress} alt="" /></i>
                    <p>{templeData.address}</p>
                  </div>
                )}
                {templeData.detail_plant && (
                <div className="detail__meta-item detail__plant">
                  <i><img src={iconPlant} alt="" /></i>
                  <p>{templeData.detail_plant}</p>
                </div>
                )}
              </div>

              {templeData.detail_text_1 && (
              <div className="detail__text">
              <p>{templeData.detail_text_1}</p>
              </div>
              )}
            </div>

            <AnimatePresence>
              {seeMore && (
                <motion.div className="detail__block"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}>
                  {templeData.more_text_1 && (
                    <div className="detail__text">
                    <p>{templeData.more_text_1}</p>
                  </div>
                  )}

                  {templeData.more_image_url_1 && (
                    <figure className="detail__image">
                      <img src={`${process.env.PUBLIC_URL}/detail_images/images/${templeData.more_image_url_1}`} alt={templeData.name_jp} />
                      {templeData.more_image_caption_1 && (
                        <figcaption>{templeData.more_image_caption_1}</figcaption>
                      )}
                    </figure>
                  )}
                </motion.div>
              )}
            </AnimatePresence>

            {(templeData.more_text_1 || templeData.more_image_url_1) && (
              <div className="detail__more">
                <a href="#" onClick={handleMoreClick}>
                  <motion.i animate={{ rotate: seeMore ? 180 : 0 }}><img src={iconCaret} alt="" /></motion.i>
                  {seeMore ? <span>閉じる</span> : <span>もっと見る</span>}
                </a>
              </div>
            )}

            <div className="detail__footer">
              {templeData.detail_jimocha_url && (
                <>
                  <p className="detail__footer-text">このスポットの情報をみんなのジモッチャで見る</p>
                  <div className="detail__btn"><a href={templeData.detail_jimocha_url} target="_blank" rel="noreferrer">ジモッチャへ</a></div>
                </>
              )}
              <div className="detail__back">
                <Link to={`/${templeData.show_on_map === 'index' ? '' : templeData.show_on_map}`}>
                  <i><img src={iconBack} /></i>
                  <span>Back</span>
                </Link>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}